import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=b9b5f436&"
import script from "./channel.js?vue&type=script&lang=js&"
export * from "./channel.js?vue&type=script&lang=js&"
import style0 from "./Channel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports